<template>
  <div class="drugs-preparation">
    <div v-if="!isMobile" class="row-fluid">
      <h4 class="gfn span6 text-uppercase">{{ guest.full_name }}</h4>
      <div class="span5">
        <div class="pull-right row-fluid">
          <div class="tutor" v-if="guest.tutor_full_name">
            <warning-msg :other-class="'span6'" :label="i18nJS.tutore" :message="guest.tutor_full_name" />
          </div>
          <div class="ammsost" v-if="guest.amm_sost_full_name">
            <warning-msg :other-class="'span6'" :label="i18nJS.amm_sost" :message="guest.amm_sost" />
          </div>
        </div>
      </div>
      <div v-if="canPrint" class="span1">
        <a href="javascript:void(0)" data-toggle="modal" :data-target="`#ds_report_${guest.id}`">
          <fa-icon :icon-name="'fa-print'" class="pulsante_comando js-tooltip" title="Stampa" />
        </a>
      </div>
    </div>
    <div class="row-fluid" v-if="i18nJS[`allergies_warning`]">
      <guest-drugs-allergies-warning
        :key="guest.id"
        :header="i18nJS[`allergies_warning`]"
        :url="allergiesUrl"
        :guest-period-data-set-id="guest.id"
      />
    </div>
    <div class="row-fluid somm somm-heading">
      <div class="span5 row-fluid">
        <div class="span2" v-if="confirmedTherapyEnabled">{{ i18nJS.confirmed_therapy }}</div>
        <div :class="[confirmedTherapyEnabled ? 'span10' : 'span12']">{{ i18nJS.drug }}</div>
      </div>
      <div class="span1 done somm_label">
        {{ i18nJS.prepared }}
        <input type="checkbox" :checked="allDone" @click="toggleAll" ref="checkAll" />
      </div>
      <div class="span1 center">{{ i18nJS.dose }}</div>
      <div class="span2 preparator">{{ i18nJS.drugs_preparations.table_preparations_for_guest.prep_on }}</div>
      <div class="span3">
        <div>{{ i18nJS.notes }}</div>
      </div>
    </div>
    <div
      v-for="(preparationsInGroup, groupVal) in groupedPreparations"
      :class="['row-fluid', 'somm', `barTherapies${groupVal}`]"
      :key="groupVal"
    >
      <h3 class="cmp-title">{{ groupVal }}</h3>
      <div v-for="(preparation, index) in preparationsInGroup" :class="['row-fluid', 'somm', `barTherapies${index}`]" :key="index">
        <div class="span5">
          <div class="center span2">
            <div v-if="confirmedTherapyEnabled">
              <fa-icon
                :icon-type="'fa'"
                :icon-name="preparation.guest_drug.confirmed ? 'fa-circle-check' : 'fa-circle-xmark'"
                :color="preparation.guest_drug.confirmed ? 'green' : 'red'"
                :no-theme="true"
              />
            </div>
            <div>
              <span>{{ preparation.guest_drug.get_somm_type }}</span>
              <p></p>
              <span class="royalblue bugiardino_link">{{ preparation.guest_drug.get_somm_form }}</span>
            </div>
          </div>
          <div class="span10">
            <div class="row-fluid">
              <div class="span10">
                <div>
                  <a
                    v-if="preparation.drug_id"
                    :href="bugiardinoLink.replace('__DRUG_ID__', preparation.drug_id)"
                    data-target="#bugiardino"
                    data-toggle="modal"
                    class="upcase"
                  >
                    {{ preparation.guest_drug.description }}
                  </a>
                  <template v-else>
                    {{ preparation.guest_drug.description }}
                  </template>
                  <template v-if="preparation.guest_drug.recurring"> ({{ preparation.guest_drug.recurring }}) </template>
                </div>
                <div v-if="preparation.guest_drug.infusion">
                  <div v-for="(description, index) in preparation.guest_drug.infusion_description" :key="index">- {{ description }}</div>
                </div>
                <div class="royalblue bugiardino_link" v-if="preparation.guest_drug.descr_principio_attivo">
                  {{ preparation.guest_drug.descr_principio_attivo }}
                </div>
                <div class="royalblue bugiardino_link" v-if="preparation.guest_drug.categoria">{{ preparation.guest_drug.categoria }}</div>
                <div
                  class="royalblue bugiardino_link"
                  v-if="preparation.guest_drug.descr_via_somministrazione || preparation.guest_drug.descr_forma_farmaceutica"
                >
                  {{ [preparation.descr_via_somministrazione, preparation.descr_forma_farmaceutica].join(' ') }}
                </div>
                <div class="royalblue bugiardino_link" v-if="preparation.guest_drug.prescrittore">
                  {{ i18nJS.prescritto_da }}: {{ preparation.guest_drug.prescrittore }}
                </div>
                <a
                  v-if="principioAttivo"
                  data-toggle="modal"
                  data-target="#modal-commercial-drugs"
                  class="bugiardino_link"
                  @click="emitCommercialDrugs(preparation)"
                  href="#"
                  >{{ i18nJS.commercial_name_associated }}</a
                >
                <div class="warning" v-if="preparation.guest_drug.notes_and_coumadin_notes">
                  {{ i18nJS.notes }}: {{ preparation.guest_drug.notes_and_coumadin_notes }}
                </div>
                <div class="warning" v-if="preparation.guest_drug.allergy_atc && preparation.guest_drug.allergy_atc.response">
                  {{ preparation.guest_drug.allergy_atc.message }}
                </div>
              </div>
              <drug-tag-label
                :therapy="preparation.guest_drug"
                :preparations-preparation-enabled="true"
                :therapies-xp-enabled="therapiesXpEnabled"
              />
            </div>
          </div>
        </div>
        <template v-if="canEdit(preparation)">
          <div class="span1 done center">
            <input
              type="checkbox"
              :checked="preparation.done"
              @click="() => togglePreparation(index, preparation)"
              :class="`toggleCheck${index}`"
            />
          </div>
          <div class="span1">
            <input type="text" v-model="preparation.qta_s" :class="['center', 'input-block-level']" min="0" :disabled="true" />
            <span v-if="preparation.qta != preparation.qta_prev" class="royalblue mypull-right">({{ preparation.get_qta_prev }})</span>
          </div>
          <div class="span2 preparator">
            <user-media
              :fullname="preparation.user.full_name"
              :img="!isMobile && preparation.user.avatar"
              :datetime="preparation.datetime_prep"
              v-if="preparation && preparation.done && preparation.user"
            />
          </div>
          <div class="span3">
            <textarea
              v-model="preparation.notes"
              rows="1"
              @change="() => updateTherapy(index, preparation)"
              :class="[`toggleCheck${index}`, 'input-block-level']"
            />
            <div class="bugiardino_link royalblue">{{ preparation.guest_drug.before_after_meal }}</div>
          </div>
        </template>
        <template v-else>
          <div class="span1">
            <fa-icon :icon-name="'fa-check'" :color="'green'" :no-theme="true" />
          </div>
          <div class="span1 center">
            {{ preparation.qta_s }}
            <span v-if="preparation.qta != preparation.qta_prev" class="royalblue">({{ preparation.get_qta_prev }})</span>
          </div>
          <div class="span2">
            {{ preparation.notes }}
            <div class="bugiardino_link royalblue">
              {{ preparation.guest_drug.before_after_meal }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <commercial-drugs-modal></commercial-drugs-modal>
    <v-modal :id="`ds_report_${guest.id}`">
      <span slot="header">
        {{ i18nJS.select_options }}
      </span>
      <ul>
        <li class="print_opt">
          <a
            :href="reportPath"
            data-remote="true"
            class="link-report js-watch-print-complete btn-print"
            data-skip-loader="true"
            data-disable-with="In stampa..."
          >
            Stampa le somministrazioni di {{ guest.full_name }} del mese corrente
          </a>
        </li>
        <li class="print_opt">
          <a href="javascript:void(0)" class="btn-print" data-toggle="modal" @click="setParamsOnModal">
            Stampa il piano terapie di {{ guest.full_name }}
          </a>
        </li>
      </ul>
    </v-modal>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import faIcon from '../faIcon';
import warningMsg from '../warningMsg';
import userMedia from '../userMedia';
import drugTagLabel from '../tagLabels/drugTagLabel';
import vModal from '../vModal';
import commercialDrugsModal from '../guestDrugs/commercialDrugsModal';
import { groupBy } from '../../plugins/arrayUtils';
import GuestDrugsAllergiesWarning from '@/epersonam/components/guestDrugs/guestDrugsAllergiesWarning.vue';
import { setupConfigMix } from '@/epersonam/mixins/setupConfig';

export default {
  name: 'guestPreparations',
  props: [
    'allergiesUrl',
    'guest',
    'groupBy',
    'preparations',
    'bugiardinoLink',
    'date',
    'time',
    'manageTherapy',
    'therapiesXpEnabled',
    'canPrint',
    'isMobile',
    'principioAttivo',
    'confirmedTherapyEnabled',
  ],
  mixins: [setupConfigMix],
  components: {
    GuestDrugsAllergiesWarning,
    userMedia,
    drugTagLabel,
    warningMsg,
    faIcon,
    vModal,
    commercialDrugsModal,
  },
  computed: {
    donePreparations() {
      if (!this.preparations) return [];

      return this.preparations.filter((t) => t.done);
    },
    groupedPreparations() {
      return this.preparations ? groupBy(this.preparations, 'hour') : null;
    },
    allDone() {
      if (!this.preparations) return false;

      return this.donePreparations.length == this.preparations.length;
    },
    i18nJS() {
      return window.i18nJS;
    },
    reportPath() {
      let url = window.config.report_path;
      url = Utils.addGetParam(url, 'gbu_id', this.guest.guest_business_unit_id);
      url = Utils.addGetParam(url, 'guest_business_unit_id', this.guest.guest_business_unit_id);
      url = Utils.addGetParam(url, 'guest_period_data_set_id', this.guest.id);
      url = Utils.addGetParam(url, 'bu_id', this.guest.business_unit_id);
      url = Utils.addGetParam(
        url,
        'd',
        moment(this.date, i18nJS.time.formats.date_only).startOf('month').format(i18nJS.time.formats.date_only),
      );
      url = Utils.addGetParam(url, 'orientation', 'landscape');
      url = Utils.addGetParam(url, 'skip_page_creation', 'false');
      return Utils.addGetParam(url, 'worker', 'DrugsSomministrationsPdfWorker');
    },
  },
  async beforeMount() {
    this.neededlabels = ['allergies_warning'];
    await this.setupLabels();
  },
  methods: {
    emitCommercialDrugs(preparation) {
      eventBus.$emit('requestDrugsCommercialName', { drug_id: preparation.guest_drug.drug_id });
    },
    disabledInput(index) {
      $('.toggleCheck' + index).prop('disabled', true);
      $('.barTherapies' + index).addClass('processing');
    },
    enabledInput(index) {
      $('.toggleCheck' + index).prop('disabled', false);
      $('.barTherapies' + index).removeClass('processing');
    },
    toggleAll() {
      var preparationsToggled = [];
      if ($(this.$refs.checkAll).is(':checked')) {
        this.preparations.forEach((preparation, index) => {
          if (!preparation.done && this.canEdit(preparation)) {
            preparationsToggled.push(preparation);
          }
        });
      } else {
        this.preparations.forEach((preparation, index) => {
          if (preparation.done && this.canEdit(preparation)) {
            preparationsToggled.push(preparation);
          }
        });
      }
      eventBus.$emit('guestInPreparation', true);
      const promises = preparationsToggled.map((preparation) => this.sendRequestTogglePreparation(preparation));
      Promise.all(promises)
        .then((values) => {
          values.forEach(({ data }, index) => {
            this.setPreparationAfterManage(this.preparations[this.preparations.indexOf(preparationsToggled[index])], data);
          });
        })
        .catch(({ data }) => {
          //this.enabledInput(index)
          alert(data);
        })
        .finally(() => eventBus.$emit('guestInPreparation', false));
    },
    sendRequestTogglePreparation(preparation) {
      this.disabledInput(this.preparations.indexOf(preparation));
      preparation.date = moment().format(i18nJS.time.formats.date_only);
      preparation.time = moment().format('H:MM');
      preparation.done = !preparation.done;
      const params = { drugs_preparation: preparation };

      return apiConnector().patch(this.manageTherapy + '.json', params);
    },
    togglePreparation(index, preparation) {
      eventBus.$emit('guestInPreparation', true);
      this.sendRequestTogglePreparation(preparation)
        .then(({ data }) => {
          this.setPreparationAfterManage(preparation, data);
        })
        .catch(({ data }) => {
          this.enabledInput(index);
          alert(data);
        })
        .finally(() => eventBus.$emit('guestInPreparation', false));
    },
    updateTherapy(index, preparation) {
      this.disabledInput(index);

      const params = { drugs_preparation: preparation };
      apiConnector()
        .patch(this.manageTherapy + '.json', params)
        .then(({ data }) => {
          this.setPreparationAfterManage(preparation, data);
        })
        .catch(({ data }) => {
          this.enabledInput(index);
          alert(data);
        });
    },
    setPreparationAfterManage(old_preparation, preparation) {
      const index = this.preparations.indexOf(old_preparation);
      let doneWithVariations, done;

      this.$set(this.preparations, index, preparation);

      // done = number of somministration done and qta == qta_prev
      // doneWithVariations = number of somministration done and qta != qta_prev
      doneWithVariations = this.preparations.filter((t) => t.id && t.qta !== t.qta_prev).length;
      done = this.preparations.filter((t) => t.id && t.qta === t.qta_prev).length;
      eventBus.$emit('toggleAlertTherapy', this.guest.id, done, doneWithVariations);
      this.enabledInput(index);
    },
    canEdit(preparation) {
      // constraint permission: posso modificare solo terapie fatte da me e che rispettino il limite di tempo massimo per la modifica
      const now = moment(),
        preparation_date_somministration = moment(preparation.start, i18nJS.time.formats.aux);
      return !preparation.done || window.userIsSuperUser == 'true' || preparation.user_id == window.userId;
    },
    setParamsOnModal() {
      $('[id*=ds_report]').modal('hide');
      $('#guest_business_unit_id_form_modal_therapy').val(this.guest.guest_business_unit_id);
      $('#guest_period_data_set_id_form_modal_therapy').val(this.guest.id);
      $('#modal_terapie_ospite').modal('show');
    },
  },
};
</script>
<style lang="scss" scoped>
.drugs-preparation {
  div.somm_label {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .processing {
    background-color: lightgray;
  }
  .upcase {
    text-transform: uppercase;
  }
  .cmp-title {
    font-size: 2.8rem;
    font-family: Asap-SemiBold;
  }
  .btn-print {
    text-transform: uppercase;
    line-height: 20px !important;
    margin-bottom: 10px;
    display: block;
    color: var(--adv-secondary-color);

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
